// extracted by mini-css-extract-plugin
export default {"supportButton":"SupportButton--supportButton--95cf1e","icon":"SupportButton--icon--b951d4","chatIcon":"SupportButton--chatIcon--5a9a56"};